import React, { useState, useEffect } from 'react';
import '../../css/DataEntryPopover.css';

export type ParameterType = 'Restoration' | 'Caries' | 'Activity' | 'Missing';

interface PopoverProps {
  x: number;
  y: number;
  onClose: () => void;
  onSave: (value: string) => void;
  parameterType: ParameterType;
  currentValue: string | null;
}

// Option definitions with descriptive labels
const OPTIONS_MAP = {
  Restoration: [
    { value: '0', label: '0: Not Restored or Sealed' },
    { value: '1', label: '1: Sealant Partial' },
    { value: '2', label: '2: Sealant Full' },
    { value: '3', label: '3: Tooth Coloured Restoration' },
    { value: '4', label: '4: Amalgam Restoration' },
    { value: '5', label: '5: Stainless steel Crown' },
    { value: '6', label: '6: Porcelain | Gold | etc.' },
    { value: '7', label: '7: Lost or Broken Restoration' },
    { value: '8', label: '8: Temporary Restoration' },
  ],
  Caries: [
    { value: '0', label: '0: No evidence of caries' },
    { value: '1', label: '1: Initial Caries' },
    { value: '2', label: '2: Distinct Visual Change' },
    { value: '3', label: '3: Localized Enamel Breakdown' },
    { value: '4', label: '4: Underlying Dark Shadow' },
    { value: '5', label: '5: Distinct Cavity' },
    { value: '6', label: '6: Extensive Distinct Cavity' },
  ],
  Activity: [
    { value: '+', label: '+: Active' },
    { value: '-', label: '-: Inactive' },
  ],
  Missing: [
    { value: 'P', label: 'P: Present' },
    { value: '97', label: '97: Missing due to caries' },
    { value: '98', label: '98: Missing for other reasons' },
    { value: '99', label: '99: Unerupted' },
  ],
};


const DataEntryPopover: React.FC<PopoverProps> = ({ x, y, onClose, onSave, parameterType, currentValue }) => {
  const [value, setValue] = useState(currentValue || '');

  useEffect(() => {
    setValue(currentValue || '');
  }, [currentValue]);

  const getOptions = () => {
    return OPTIONS_MAP[parameterType] || [];
  };

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if ((event.target as HTMLElement).closest('.popover-content')) return;
      onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="popover-content">
      <h4 className="popover-title">{parameterType}</h4>
      <select value={value} onChange={e => setValue(e.target.value)} className="popover-select">
        <option value="">-- Select --</option>
        {getOptions().map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      <div className="popover-actions">
        <button onClick={handleSave} className="popover-btn-save">Save</button>
      </div>
    </div>
  );
};

export default DataEntryPopover;
